import { signal } from '@preact/signals-react';
import { ANYONE_ID } from 'Calendar/anyone';
import { IDatePickerValue } from 'components/DatePicker';
import moment from 'utils/moment';
import { IBodyApiQuickBooking } from 'services/types/quickBooking';
import { ICustomerUI } from 'types/customer';
import getTimeLines, { setTime } from 'utils/getTimeLines';
import uuid from 'utils/uuid';
import { customerSectionRef } from './Customer';
import { IStaffUI } from 'types/staff';
import React from 'react';
const openSignal = signal<boolean>(false);
const openDropDownCs = signal<boolean>(false);
const staffs = signal<string[]>([]);
const requestStaff = signal<boolean>(false);
const currentDate = signal<IDatePickerValue | null>(moment());
const startTime = signal<string>('');
const note = signal<string>('');
const callerId = signal<string>('');
const duration = signal<number>(15);
const totalPeople = signal<number>(1);
const customer = signal<ICustomerUI | null>(null);

export type IQuickServiceItem = {
  value: string;
  label: any;
  id: number | string;
}
const services = signal<IQuickServiceItem[]>([]);
const uuidKey = signal<string>(uuid());

export type IQuickBookStaffSelected = {
  id: string;
  requestStaff?: boolean;
  services: IQuickServiceItem[];
};

const _timeLines = getTimeLines(setTime(9, 0), setTime(21, 0), 15).map(o => ({
  value: o.value.format('hh:mm A'),
  label: o.value.format('hh:mm A'),
}));
const timelines = signal<{
  value: string;
  label: string;
}[]>(_timeLines);

export interface IQuickBookRef {
  initFormService: (data: IQuickBookStaffSelected[]) => void;
}
export const quickbookRef = React.createRef<IQuickBookRef>();

// const getAvailableTimeslotByStaff = async (params: { currentDate: string, staffId: string }) => {
//   if (!params.currentDate || !params.staffId) return;
//   try {
//     const res: AxiosResponse<{ payload: { timeSlots: string[] } }> = await apis.getAvailableTimeSlotByStaff(params);
//     if (res.data.payload.timeSlots) {
//       const timeslots = res.data.payload.timeSlots;
//       timelines.value = timeslots.map(o => ({ value: o, label: o }));
//       if (!timeslots.includes(startTime.value)) {
//         startTime.value = first(timeslots) || '';
//       }
//     } else {
//       timelines.value = [];
//     }
//   } catch (error) { }
// };

// effect(() => {
//   const params = {
//     currentDate: currentDate.value?.format('MM-DD-YYYY') || '',
//     staffId: staffs.value[0] || '',
//   };
//   getAvailableTimeslotByStaff(params);
// });

const qbSignal = {
  openSignal,
  requestStaff,
  customer,
  startTime,
  duration,
  staffs,
  totalPeople,
  note,
  services,
  currentDate,
  timelines,
  uuidKey,
  openDropDownCs,
  callerId,
  open: (staffId: string, _startTime: string, additionalData?: { requestStaff?: boolean, customer?: ICustomerUI, callerId?: string, }) => {
    const currentDateValue = moment(_startTime);
    openSignal.value = true;
    currentDate.value = currentDateValue;
    startTime.value = currentDateValue.format('hh:mm A');
    duration.value = 60;
    staffs.value = [staffId];
    requestStaff.value = additionalData?.requestStaff || false;
    customer.value = additionalData?.customer || null;
    uuidKey.value = uuid();
    services.value = [];
    note.value = '';
    totalPeople.value = 1;
    callerId.value = additionalData?.callerId || '';
    timelines.value = _timeLines;
    quickbookRef.current?.initFormService([{
      id: staffId,
      requestStaff: additionalData?.requestStaff || false,
      services: [],
    }]);
    if (!customer.value) {
      setTimeout(() => {
        customerSectionRef.current?.focus();
      }, 500);
    }
  },
  close: () => {
    openSignal.value = false;
  },
  getCurrentStartEndTime: () => {
    const timeStr = `${currentDate.value?.format('MM-DD-YYYY')} ${startTime.value}`;
    const _startTime = moment(timeStr, 'MM-DD-YYYY hh:mm A').format('MM-DD-YYYY HH:mm');
    const _endTime = moment(_startTime).add(duration.value, 'minute').format('MM-DD-YYYY HH:mm');

    return ({
      startTime: _startTime, endTime: _endTime
    });
  },
  getValues: (staffsSelected: IQuickBookStaffSelected[]) => {
    const timeStr = `${currentDate.value?.format('MM-DD-YYYY')} ${startTime.value}`;
    const _startTime = moment(timeStr, 'MM-DD-YYYY hh:mm A').format('MM/DD/YYYY HH:mm');
    return staffsSelected.map(o => ({
      customerId: parseInt(customer.value?.id || '') || '',
      bookingType: 0,
      duration: duration.value,
      isAnybody: o.id === ANYONE_ID ? 1 : 0,
      note: totalPeople.value > 1 ? `Group ${totalPeople.value}: ${note.value || ''}` : (note.value || ''),
      requestStaff: o.requestStaff,
      services: o.services.map(s => ({
        id: s.id || 0,
        serviceName: s.label,
        price: 0,
      })),
      staffId: parseInt(o.id),
      startTime: _startTime,
      totalPeople: totalPeople.value || 1,
      callerId: callerId.value || '',
    } as IBodyApiQuickBooking));
  },
};

export default qbSignal;
